<template>
  <div class="ig">
    <div class="ig-tabs" role="tablist" aria-label="Where your website is built">
      <button v-for="item in guides" :key="item.key" type="button" role="tab" :aria-selected="current === item.key ? 'true' : 'false'"
              :class="['ig-tab', { active: current === item.key }]" @click="current = item.key">{{ item.name }}</button>
    </div>
    <div class="ig-panel" role="tabpanel">
      <ol class="ig-steps"><li v-for="step in active.steps" :key="step">{{ step }}</li></ol>
      <p v-if="active.note" class="pb-note ig-note"><i class="mdi mdi-information-outline pb-ico" aria-hidden="true"></i><span>{{ active.note }}</span></p>
    </div>
    <p class="pb-muted ig-fallback">If a site blocks scripts, the code simply shows a link to your hosted wall, so nothing breaks. You can also link to the wall directly.</p>
  </div>
</template>

<script>
export const GUIDES = [
  { key: 'html', name: 'HTML', steps: ['Copy the code.', 'Paste it into your page where the testimonials should appear, inside <body>.', 'Publish the page.'] },
  { key: 'wordpress', name: 'WordPress', steps: ['Edit the page and add a Custom HTML block where the testimonials should go.', 'Paste the code and update the page.'],
    note: 'WordPress.com runs scripts only on plans that allow plugins. On other plans the block shows the link to your hosted wall.' },
  { key: 'webflow', name: 'Webflow', steps: ['Drag an Embed element onto the page.', 'Paste the code, save and publish.'],
    note: 'Embeds run on the published site; the Designer may only show the link.' },
  { key: 'squarespace', name: 'Squarespace', steps: ['Add a Code block where the testimonials should go.', 'Paste the code, turn off "Display source" and save.'],
    note: 'Scripts in Code blocks need a Squarespace plan that allows custom code. Without it, the block shows the link to your hosted wall.' },
  { key: 'wix', name: 'Wix', steps: ['Add Embed code › Embed HTML.', 'Choose Code, paste the code and click Update.', 'Drag the box taller: Wix shows embeds in a fixed-height box, so give it room for your testimonials.'],
    note: 'Wix doesn\'t resize the box on its own. On phones, check the height in the mobile editor too.' },
  { key: 'framer', name: 'Framer', steps: ['Insert an Embed and choose HTML.', 'Paste the code and publish.'],
    note: 'The widget appears on the published site and in preview.' },
  { key: 'shopify', name: 'Shopify', steps: ['In Online Store › Themes › Customize, add a Custom Liquid section or block.', 'Paste the code and save.'] }
];

export default {
  name: 'InstallGuide',
  data: () => ({ guides: GUIDES, current: 'html' }),
  computed: { active() { return this.guides.find(item => item.key === this.current) || this.guides[0]; } }
};
</script>

<style scoped>
.ig-tabs{display:flex;flex-wrap:wrap;gap:6px;margin-bottom:14px}
.ig-tab{min-height:40px;padding:6px 14px;border:1px solid #D4C9B8;border-radius:999px;background:#fff;font:600 13.5px var(--font-body);color:#4F4A45;cursor:pointer}
.ig-tab:hover{border-color:#8C8378;color:#1F2328}
.ig-tab.active{background:#1F2328;border-color:#1F2328;color:#fff}
.ig-steps{margin:0;padding-left:20px;display:grid;gap:6px;font-size:14.5px;line-height:1.55;color:#1F2328}
.ig-note{margin:14px 0 0}
.ig-fallback{margin-top:14px}
</style>
